import type { Event } from '@/types/event';

export interface EventTimeRange {
    isScene: boolean;
    startTime?: number;
    endTime?: number;
}

export function getEventTimeRange(event: Event): EventTimeRange {
    const isScene = event.type === 'SCENE';
    if (!isScene) {
        return {
            isScene,
            startTime: event.frames?.[0]?.time,
            endTime: event.frames?.[event.frames.length - 1]?.time,
        };
    }

    return {
        isScene,
        startTime: event.startTime,
        endTime: event.endTime,
    };
}
